import NewUserForm from "./NewUserForm"
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
function NewUser() {
    useTitle('geshtop-Exercise: New User')


    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    if (!groups?.length) return <PulseLoader color={"#FFF"} />
    const content = <NewUserForm groups={groups} />
    return content

}

export default NewUser